"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCallRecord = createCallRecord;
exports.updateCallRecord = updateCallRecord;
exports.updateCallRecords = updateCallRecords;
exports.createRest = createRest;
exports.addRelation = addRelation;

var _request = _interopRequireDefault(require("@/utils/request"));

var _qs = _interopRequireDefault(require("qs"));

function createCallRecord(data) {
  return (0, _request.default)({
    url: '/calllogRecord/create',
    method: 'post',
    data: data
  });
}

function updateCallRecord(data) {
  return (0, _request.default)({
    url: '/calllogRecord/update',
    method: 'post',
    data: data
  });
}

function updateCallRecords(data) {
  return (0, _request.default)({
    url: '/calllogRecord/updateCallRecords',
    method: 'post',
    data: data
  });
} //保存小休信息


function createRest(data) {
  return (0, _request.default)({
    url: '/admin/createUserRest',
    method: 'post',
    data: data
  });
}

function addRelation(data) {
  return (0, _request.default)({
    url: '/ticket/addRelation',
    method: 'post',
    data: data
  });
}